<template>
  <!-- 修改手机号 -->

  <el-dialog :visible.sync="visiblePhone" append-to-body width="30%" :show-close="true" :close-on-click-modal="false" :before-close="closeModal">
    <section class=" edit-phone">
      <section class="title-content">
        <div class="phone-lable">
          请输入新的手机号码
        </div>
        <div class="phone-new">
          <span>
            您要更换的手机号码为：
          </span>
          <span v-if="oldPhone">
            {{ oldPhone }}
          </span>
          <span v-else>
            未绑定
          </span>
        </div>
      </section>

      <section class="home-content">
        <el-form key="b" class="user-layout-login" ref="form" :model="modelPass" :rules="validatorRulesPass" @keyup.enter.native="handleSubmit">
          <el-form-item required prop="usernameFirst" class="item-first">
            <el-input v-model="modelPass.usernameFirst" maxlength="11" size="large" placeholder="请输入手机号">

            </el-input>
          </el-form-item>
          <el-form-item required prop="code">
            <el-input placeholder="请输入验证码" maxlength="6" size="large" v-model="modelPass.code">
              <template slot="append">
                <span class="code-text" v-if="canClickCode" @click="getCode">获取验证码</span>
                <span class="code-timer" v-else>{{ smsBtnTxt }}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="form-bottom">
            <el-button size="large" type="primary" :disabled="submitBtn" class="login-button" @click.stop.prevent="handleSubmit">确定
            </el-button>
          </el-form-item>

        </el-form>
      </section>
    </section>
  </el-dialog>
</template>
<script>
import homeHead from "../../component/homeHead.vue";
import {
  sendChangePhoneSms, changeAccountPhone, getMyUserInfo
} from '../../../../api/api.p'
import { dateFormat, validatePhone } from '../../../../../src/libs/util'
export default {
  props: {
    visiblePhone: {
      type: Boolean,
      default: false
    },
  },
  data () {
    var validatePhone = (rule, value, callback) => {
      let reg = /^0?1[3|4|5|6|7|8|9]\d{9}$/;
      if (value == '') {
        callback(new Error('请输入手机号！'));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号！'));
        }
      }
    };
    return {
      selectUrl: 'info',
      urlData: [
        {
          name: '个人信息',
          value: 'info'
        }
      ],
      oldPhone: '',
      modelPass: {
        usernameFirst: '',
        code: '',
      },
      validatorRulesPass: {
        usernameFirst: [
          { required: true, validator: validatePhone }
        ],
        code: [
          { required: true, message: '请输入验证码!' }
        ]
      },
      passwordFlag: 'password',
      smsBtnTxt: '',
      canClickCode: true,
      submitBtn: false
    }
  },
  filters: {
    dateFormatFilter (val) {
      let str = ''
      str = val ? dateFormat('yyyy-MM-dd hh:mm:ss', val + '000') : '--'
      return str
    }
  },
  components: {
    homeHead
  },
  created () {

  },
  mounted () {

  },
  methods: {
    init () {
      this.oldPhone = JSON.parse(localStorage.getItem('userUnifyInfo')).phone
      this.getMyUserInfo()
    },
    getMyUserInfo () {
      getMyUserInfo().then(res => {
        if (res.meta.code == 0) {
          // window.sessionStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
          // localStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
          this.oldPhone = res.data.phone || '';
        } else {
          this.$toast(res.meta.message)
        }
      })
        .catch(err => {
          // debugger;
          this.$toast(err.meta.message)
        })
    },
    // 获取验证码
    getCode () {
      if (!this.canClickCode) {
        return false
      }
      if (this.modelPass.usernameFirst == '') {
        this.$toast('手机号不能为空');
        return
      } else {
        if (!validatePhone(this.modelPass.usernameFirst)) {
          this.$toast('手机号格式不正确');
          return
        } else {
          this.canClickCode = false

          let params = {
            phone: this.modelPass.usernameFirst
          }
          sendChangePhoneSms(params).then(res => {
            if (res.meta.code === 0) {
              let sec = 59
              this.smsBtnTxt = sec + 's'
              this.timer = setInterval(() => {
                --sec
                if (sec < 0) {
                  clearInterval(this.timer)
                  this.canClickCode = true
                  // this.smsBtnTxt = '获取验证码'
                } else {
                  this.smsBtnTxt = sec + 's'
                }
              }, 1000)
            } else {
              this.$toast(res.meta.message);
              this.canClickCode = true
            }
          })
        }
      }
    },
    closeModal () {
      this.modelPass = {
        usernameFirst: '',
        code: '',
      };
      this.$refs['form'].resetFields();
      this.$emit('closes');
    },
    handleSubmit () {
      this.submitBtn = true;
      this.$refs['form'].validate(valid => {
        if (valid) {
          //   return
          let params = {
            "newPhone": this.modelPass.usernameFirst,
            verificationCode: this.modelPass.code
          }
          changeAccountPhone(params).then((res) => {
            if (res.meta.code == 0) {
              this.$toast(res.meta.message)
              // sessionStorage.removeItem("userToken")
              var url = location.search;
              var str = '';
              if (url.indexOf("?") != -1) {
                let urlStr = url.split('?')[1]
                let paramsArr = urlStr.split('&')
                // 再通过 = 将每一个参数分割为 key:value 的形式
                let arr = paramsArr[i].split('=')
                str = arr[1];
              }
              if (this.$route.query.push == true || str == 'true' || str == true) {
                this.$router.back();
              }
              window.parent.postMessage("closeDialog", '*');
              this.closeModal()
            } else {
              this.$toast(res.meta.message);
              this.submitBtn = false;
            }
          }).catch((err) => {
            this.$toast(err.meta.message)
            this.submitBtn = true;
          })
        } else {
          this.submitBtn = false;
        }
      })
    },
  }
}
</script>
  
<style lang="less" scoped>
@import './../../../../common/homeInfo';
.edit-phone {
  width: 100%;

  .title-content {
    padding: 50px 30px 25px 30px;
    text-align: center;

    .phone-lable {
      color: #121924;
      font-weight: bold;
      font-size: 21px;
    }

    .phone-new {
      color: #999999;
      font-weight: 400;
      font-size: 14px;
      padding-top: 8px;
    }
  }
  @media (min-width: 500px) {
    .edit-content {
      width: 350px;
      margin: 0 auto;
    }
    .home-content {
      align-items: center;
    }
    .title-content {
      padding: 50px 30px 25px 16px;
    }
  }

  .home-content {
    padding: 25px 30px;
    display: flex;
    //   justify-content: center;
    //   flex-wrap: wrap;
    flex-direction: column;

    .user-layout-login {
      width: 315px;
      .item-first {
        margin-bottom: 30px;
      }

      label {
        font-size: 14px;
      }

      .form-bottom {
        position: relative;

        .pass-text {
          position: absolute;
          bottom: 40px;
          right: 0;
          color: #4086f6;
          font-size: 12px;
          cursor: pointer;
        }
      }

      button.login-button {
        padding: 0 15px;
        font-size: 16px;
        height: 40px;
        width: 100%;
        margin-top: 70px;
      }
    }

    /deep/.el-input__inner {
      border: none !important;
      background: #f5f5f5;
      font-size: 18px;
    }

    .el-button--primary {
      background: #4086f6;
    }

    .el-button {
      border: none;
    }

    /deep/.el-input-group__append {
      border: none;
      background: #f5f5f5;
      color: #4086f6;
      font-size: 14px;

      .code-text {
        cursor: pointer;
      }

      .code-timer {
        color: #999;
      }
    }
  }
  /deep/.el-input__inner {
    &::placeholder {
      font-size: 16px;
    }
  }
}
</style>
  
  